import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { KeycloakService } from 'keycloak-angular';
import { FooterComponent } from '../../shared/components/footer/footer.component';
import { LoginModalComponent } from '../../shared/components/login-modal/login-modal.component';
import { ReferenceDatasetsComponent } from '../reference-datasets/reference-datasets.component';

@Component({
  selector: 'app-submit-model-page',
  standalone: true,
  imports: [
    CommonModule,
    FooterComponent,
    LoginModalComponent,
    ReferenceDatasetsComponent,
  ],
  templateUrl: './submit-model-page.component.html',
  styleUrl: './submit-model-page.component.scss',
})
export class SubmitModelPageComponent implements OnInit {
  private keycloak = inject(KeycloakService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);

  isLoggedIn = false;
  showLoginModal = false;
  loginRedirectUri = '';
  datasetKey = this.route.snapshot.queryParamMap.get('dataset');
  datasetLabel = this.route.snapshot.queryParamMap.get('label');

  async ngOnInit(): Promise<void> {
    this.loginRedirectUri = `${window.location.origin}${this.router.url}`;

    try {
      this.isLoggedIn = await this.keycloak.isLoggedIn();
      if (!this.isLoggedIn) {
        this.showLoginModal = true;
      }
    } catch {
      this.showLoginModal = true;
    }
  }

  onLoginModalClose(visible: boolean): void {
    this.showLoginModal = visible;
    if (!visible && !this.isLoggedIn) {
      this.router.navigate(['/datasets']);
    }
  }
}
